

import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Initialize authentication state based on the presence of a token in localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token"));

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    // Clear token and user data from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    setIsAuthenticated(false);
  };

  // Automatically log out if token is missing on page refresh
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      logout();
    }
  }, []); // Run once on component mount

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
